import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  state: {
    goodFlows: [],
    flowFilters: null,
    flowTypes: [],
    flowType: {},
    flowStatuses: [],
    goodFlow: {},
    flowItems: [],
    qtyUnits: [],
    count: 0,
    flowItemsCount: 0,
  },
  getters: getters,
  mutations: mutations,
  actions: actions,
}
